import {
  SET_AUTHENTICATED,
  SET_UNAUTHENTICATED,
  UserDispatchTypes,
  LoginSignUpApiRes,
  GetLoggedInUserApiRes,
  SET_USER,
  ForgotResetPasswordApiRes,
  FORGOT_RESET_PASSWORD,
  CLEAR_MESSAGE,
  CLEAR_ERROR_MESSAGE,
  REMOVE_USER,
  CONTACT_SUBSCRIBE,
  CLEAR_CONTACT_SUBSCRIBE_MESSAGE,
} from "../../types/user/UserActionTypes";

interface InitialStateI {
  authenticated: boolean;
  message?: string;
  loginSignUpData?: LoginSignUpApiRes;
  loggedInUserData?: GetLoggedInUserApiRes;
  forgotResetPassword?: ForgotResetPasswordApiRes;
}
const initialState: InitialStateI = {
  authenticated: false,
};

const UserReducer = (
  state: InitialStateI = initialState,
  action: UserDispatchTypes
): InitialStateI => {
  switch (action.type) {
    case SET_UNAUTHENTICATED:
      return {
        ...state,
        authenticated: false,
        loginSignUpData: action.payload,
      };
    case SET_AUTHENTICATED:
      return {
        ...state,
        authenticated: true,
        loginSignUpData: action.payload,
      };
    case SET_USER:
      return {
        ...state,
        authenticated: true,
        loggedInUserData: action.payload,
      };
    case FORGOT_RESET_PASSWORD:
      return {
        ...state,
        forgotResetPassword: action.payload,
      };
    case CLEAR_MESSAGE:
      return {
        ...state,
        loggedInUserData: {
          ...state.loggedInUserData,
          message: "",
        },
      };
    case CLEAR_ERROR_MESSAGE:
      return {
        ...state,
        loggedInUserData: {
          ...state.loggedInUserData,
          errMessage: "",
        },
      };
    case REMOVE_USER:
      return {
        ...state,
        message: action.payload?.message,
        loggedInUserData: {},
      };
    case CONTACT_SUBSCRIBE:
      return {
        ...state,
        message: action.payload.message,
      };
    case CLEAR_CONTACT_SUBSCRIBE_MESSAGE:
      return {
        ...state,
        message: "",
      };
    default:
      return state;
  }
};
export default UserReducer;
